import axios from "axios";
const endpoint = process.env.VUE_APP_BASE_API + "/api/shop/invoices";
const config = {
  headers: { _pub: "true" }
};

export default {
  async getListInvoices(param) {
    return await axios
      .get(endpoint + `?${param}`)
      .then(response => {
        return response.data;
      })
      .catch(error => {
        throw error.response.data;
      });
  },
  async getRetrieveInvoice(id) {
    return await axios
      .get(endpoint + `/${id}`)
      .then(response => {
        return response.data;
      })
      .catch(error => {
        throw error.response.data;
      });
  },
  async getPublicRetrieveInvoice(id, query) {
    return await axios
      .get(endpoint + `/${id}/pub?${query}`, config)
      .then(response => {
        return response.data;
      })
      .catch(error => {
        throw error.response.data;
      });
  },
  async getAllUnpaidBookings(companyId) {
    return await axios
      .get(endpoint + `/company/${companyId}/unpaid_bookings`)
      .then(response => {
        return response.data;
      })
      .catch(error => {
        throw error.response.data;
      });
  },
  async createOfflineInvoice(request) {
    return await axios
      .post(endpoint + `/create_offline_invoice`, request)
      .then(response => {
        return response.data;
      })
      .catch(error => {
        throw error.response.data;
      });
  },
  async markAsPaid(id, request) {
    return await axios
      .post(endpoint + `/${id}/mark_as_paid`, request)
      .then(response => {
        return response.data;
      })
      .catch(error => {
        throw error.response.data;
      });
  },
  async updateInvoice(id, request) {
    return await axios
      .put(endpoint + `/${id}`, request)
      .then(response => {
        return response.data;
      })
      .catch(error => {
        throw error.response.data;
      });
  },
  async postToQBO(request) {
    return await axios
      .post(endpoint + `/post_to_qbo`, request)
      .then(response => {
        return response.data;
      })
      .catch(error => {
        throw error.response.data;
      });
  }
};



// WEBPACK FOOTER //
// ./src/services/shop/invoiceService.js